import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseRequest } from "../utils/Classes/Requests/BaseRequest";
import axios from "axios";
import TS from '../utils/TimeStampGenerator'
import { config } from "../utils/Constants";

const URL = config.url;

const initialState = {
  authorizationCode: "",
  qrData: "",
  status: "",
  // api: "",
  qrTimeout: false,
  loading: "idle",
  opLoading: "idle",
  actionType: "",
  actionPayload: null,
  error: null,
};

export const generateAuthorizationCode = createAsyncThunk(
  "Authorization/GenerateAuthorizationQrCode",
  async () => {
    const req = new BaseRequest(sessionStorage.getItem("SessionID"));
    const res = await axios.post(
      `${URL}/v1/Authorization/GenerateAuthorizationQrCode`,
      req,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("Token"),
        }
      }
    );
    return res.data;
  }
);

export const checkAuthorizationStatus = createAsyncThunk(
  "Authorization/CheckAuthorizationQrCode",
  async (params) => {
    const { authCode, controller } = params;
    // axios.defaults.signal = controller.signal;
    if (authCode && authCode.length > 0) {
      try {
        const res = await axios.post(
          `${URL}/v1/Authorization/PortalActionsAuthorizationStatus`,
          {
            //Body
            SessionID: sessionStorage.getItem("SessionID"),
            TS: TS(),
            AuhtorizationCode: authCode,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: sessionStorage.getItem("Token"),
            },
            signal: controller.signal
          }
        );
        const status = res.data.Payload.Status;
        return status;
      } catch (e) {
        throw e;
      }

    }
  }
);

export const getExpAuthCodeOnClose = createAsyncThunk(
  "Authorization/ExpireAuthorizationCodeOnClose",
  async (params) => {
    const { authCode } = params;
    await axios.post(
      `${URL}/v1/Authorization/ExpireAuthorizationCodeOnClose`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        TS: TS(),
        AuthorizationCode: authCode,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("Token"),
        }
      }
    );
  }
);

const authorizationCodeSlice = createSlice({
  name: "authorizationCode",
  initialState,
  reducers: {
    setAuthorizationCode: (state, action) => {
      state.authorizationCode = action.payload;
    },
    setQrData: (state, action) => {
      state.qrData = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setOpLoading: (state, action) => {
      state.opLoading = action.payload;
    },
    setAuthorizationCodeStatus: (state, action) => {
      state.status = action.payload;
    },
    setQrTimeout: (state, action) => {
      state.qrTimeout = action.payload;
    },
    setActionType: (state, action) => {
      state.actionType = action.payload;
    },
    setActionPayload: (state, action) => {
      state.actionPayload = action.payload;
    },
    resetState: (state) => {
      state = { ...initialState };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(generateAuthorizationCode.pending, (state) => {
      if (state.loading === "idle") state.loading = "pending";
    });
    builder.addCase(
      generateAuthorizationCode.fulfilled,
      (state, action) => {
        if (state.loading === "pending") {
          state.loading = "idle";
          state.qrData = action.payload.Payload.QrCode;
          state.authorizationCode = action.payload.Payload.AuthorizationCode;
          state.qrTimeout = false;
          state.error = null;
        }
      }
    );
    builder.addCase(generateAuthorizationCode.rejected, (state, action) => {
      if (state.loading === "pending") {
        state.qrData = "";
        state.authorizationCode = "";
        state.loading = "idle";
        state.error = action.error;
      }
    });
    builder.addCase(
      checkAuthorizationStatus.fulfilled,
      (state, action) => {
        state.status = action.payload;
        // state.qrTimeout = !(action.payload === "PENDING")
      }
    );
    builder.addCase(checkAuthorizationStatus.rejected, (state, action) => {
      state.qrData = "";
      state.authorizationCode = "";
      state.qrTimeout = true;
      state.error = action.error;
    });
  },
});

export const { setActionType, setActionPayload, setAuthorizationCode, setQrTimeout, setQrData, setStatus, setOpLoading } = authorizationCodeSlice.actions;

export default authorizationCodeSlice.reducer;
